// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-color-picker[data-v-5cab1bfc]{display:flex;position:absolute;top:30px;left:30px;border:1px solid rgba(0,0,0,.2)}.v-color-picker .color[data-v-5cab1bfc]{width:30px;height:30px;transition:all .2s ease}.v-color-picker .color[data-v-5cab1bfc]:hover{transform:scale(1.2);transition:all .2s ease;box-shadow:0 0 5px rgba(0,0,0,.2);cursor:pointer}.v-color-picker .bg-white[data-v-5cab1bfc]{background-color:#fff}", ""]);
// Exports
module.exports = exports;
